import { FormItem } from "./FormItem";
import { Div } from "../../Div";
import { toMap } from "../../../../../HA";

export class Button extends FormItem {

    public getType() {
        return "Button";
    }

    protected createSelf() {
        if (this.hasNot("ft")) {
            const btn = new Div();
            btn.addClass("buttonbox");
            btn.setText(this.get("v"));
            this.setElement(btn.getElement());
            return;
        }

        // The button's own class (mockup `class`/`className`) belongs on the
        // rendered button element, not on the `.formi` wrapper. Read it here and
        // drop it from the data bag so Tag.initialize doesn't also apply it to the
        // wrapper — a double application styles the wrapper instead of the button.
        const extraClass = this.get("class") || this.get("className");
        this.remove("class");
        this.remove("className");

        const btn = this.getRenderer().renderButton({
            ft:         this.get("ft"),
            formId:     this.get("formid"),
            label:      this.get("label"),
            icon:       this.get("i"),
            extraClass,
        });
        this.setElement(btn.getElement());
    }

    protected initialize(data: any) {
        if (typeof data === "string") {
            data = toMap({v: data});
        }
        super.initialize(data);
    }
}
